<template>
  <v-row dense>
    <v-col cols="12">
      <px-autocomplete-cadastro-adicional
        :dense="dense"
        type="ARMAZEM"
        label="Armazém"
        required
        class="required rounded-tag-small"
        v-model="formData.armazem"/>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
